export const WD_CONTENT = {
  seo: {
    title: 'Webinar Gratuito de DRE: Sua empresa deu lucro mês passado? | 77Gestão',
    description:
      'Aula ao vivo e gratuita com um BPO financeiro: aprenda a ler o DRE da sua empresa, mesmo sem ser da área. Quinta, 16/07/2026, às 20h. Vagas limitadas.',
  },

  event: {
    dateLabel: 'Quinta, 16/07/2026',
    timeLabel: '20h00',
    formatLabel: 'Online e ao vivo',
  },

  hero: {
    badge: 'Webinar gratuito e ao vivo',
    title: 'Sua empresa deu lucro mês passado?',
    subtitle:
      'A maioria dos empreendedores não sabe responder com certeza. Numa aula ao vivo com um BPO financeiro, você vai aprender a ler o DRE da sua empresa — mesmo sem ser da área.',
  },

  // Configuração do formulário (Static Forms — envio assíncrono)
  form: {
    endpoint: 'https://api.staticforms.dev/submit',
    apiKey: '88d22151-70a0-4a81-9f0d-c35e3cf8e10b',
    subject: 'Nova inscrição — Webinar DRE 16/07',
    title: 'Garanta sua vaga',
    free: '100% gratuito · vagas limitadas',
    submit: 'Quero minha vaga gratuita',
    submitting: 'Enviando...',
    privacy: 'Seus dados estão seguros. Sem spam.',
    errorMsg: 'Ops, não consegui enviar agora. Tente novamente em instantes.',
    controleLabel: 'Como você controla suas finanças hoje?',
    controleOptions: [
      'Não tenho controle / faço de cabeça',
      'Planilha',
      'Já uso um software de gestão',
      'Contador ou BPO cuida disso',
    ],
    success: {
      title: 'Vaga garantida!',
      text: 'Enviamos a confirmação para o seu e-mail. No dia 16/07 às 20h você recebe o link de acesso. Até lá!',
    },
  },

  caminhos: {
    title: '3 formas de ter o controle do seu resultado',
    lead: 'Na aula, o BPO mostra cada caminho na prática para você escolher o que cabe na sua realidade hoje.',
    items: [
      {
        num: 'CAMINHO 1',
        title: 'Sozinho, na planilha',
        text: 'Funciona e é de graça. Você vai ver como montar — e onde mora o risco de erro que distorce seu resultado.',
        icon: 'fa-solid fa-table-cells',
      },
      {
        num: 'CAMINHO 2',
        title: 'No software de gestão',
        text: 'O mesmo controle, automático, sem fórmula quebrada. Como o 77Gestão monta seu DRE sozinho.',
        icon: 'fa-solid fa-gauge-high',
      },
      {
        num: 'CAMINHO 3',
        title: 'Com um BPO financeiro',
        text: 'Alguém especializado cuidando do seu financeiro pra você focar no negócio e dormir tranquilo.',
        icon: 'fa-solid fa-user-tie',
      },
    ],
  },

  paraQuem: {
    title: 'Essa aula é pra você se…',
    items: [
      'Você olha o saldo da conta, mas não sabe se realmente teve lucro.',
      'Sua empresa fatura, mas o dinheiro "some" e você não sabe pra onde.',
      'Você nunca estudou finanças e acha DRE coisa de contador.',
      'Você quer parar de tomar decisão no escuro e começar a usar números.',
    ],
  },

  host: {
    title: 'Quem conduz',
    text: 'A aula é conduzida por um BPO financeiro com experiência real ajudando pequenas empresas a organizar o caixa e enxergar o resultado — junto com o time do 77Gestão.',
  },

  ctaFinal: {
    title: 'Pare de adivinhar. Comece a saber.',
    subtitle: 'Quinta, 16/07/2026, às 20h. Ao vivo e gratuito. Vagas limitadas.',
    cta: 'Garantir minha vaga',
  },
};
